import request from "../helpers/request";
import {createRestfulApi} from "@/api/createRestfulApi";

const URL = {
    DEMO_LOGIN: "auth/demoLogin",
    LOGIN: "auth/login",
    LOGINOUT: "auth/logout",
    REGISTER: "auth/register",
    SENDSMS: "auth/sendSms",
    REGISTER_TENANT: "auth/registerTenant",
    USERINFO: "user/userInfo",
    GET_USER_PERMISSION: "user/getUserPermission",
    UPDATEUSERINFO: "user/updateUserInfo",
    GET_SYSTEM_MESSAGE: "user/getSystemMessage",
    ADD_MESSAGE_RECEIVE: "user/addMessageReceive",
    // 重定向到微信扫码弹框
    AUTHORIZE: "auth/wechat/authorize",
};

export default {
    getSystemMessage: createRestfulApi(URL.GET_SYSTEM_MESSAGE, {
        queryParams: [],
    }),
    addMessageReceive(payload) {
        return request(URL.ADD_MESSAGE_RECEIVE, "POST", payload);
    },
    demoLogin() {
        return request(URL.DEMO_LOGIN, "POST", {});
    },
    login({captcha, password, phone, authUnionId}) {
        return request(URL.LOGIN, "POST", {
            captcha,
            password,
            phone,
            authUnionId,
        });
    },
    loginOut() {
        return request(URL.LOGINOUT, "GET");
    },
    register({captcha, password, phone}) {
        return request(URL.REGISTER, "POST", {
            captcha,
            password,
            phone,
        });
    },
    sendSms({phone}) {
        return request(URL.SENDSMS, "POST", {
            phone,
        });
    },
    registerTenant(payload) {
        return request(URL.REGISTER_TENANT, "POST", payload);
    },
    getUserInfo() {
        return request(URL.USERINFO, "GET");
    },
    getUserPermission() {
        return request(URL.GET_USER_PERMISSION, "GET");
    },
    updateUserInfo({avatar, id, nickname, password, phone}) {
        return request(URL.UPDATEUSERINFO, "POST", {
            avatar,
            id,
            nickname,
            password,
            phone,
        });
    },
    getAuthorize() {
        return request(URL.AUTHORIZE, "GET");
    },
};
